import {instance} from "./agent";
import {APIResponseType, NsiItem} from "./types";

let lang = document.cookie.split('; ').find(r => r.startsWith('lang'))?.split('=')[1]

const nsi = {
    getUserTypes() {
        return instance.get<APIResponseType<NsiItem[]>>('/nsi/getUserTypes').then(res => res.data)
    },
    getDocTypes() {
        return instance.get<APIResponseType<NsiItem[]>>('/nsi/getDocTypes').then(res => res.data)
    },
    getCountryByName(name: string) {
        return instance.get<APIResponseType<NsiItem[]>>(`/nsi/getCountryByName?name=${name}`).then(res => res.data)
    }
}

export default nsi